import Cookie from "js-cookie";

export const INITIAL_STATE = {
  token: Cookie.get("auth_token") || "",
  isLoggedIn: false,
  profile: {},
  profileOptions: [],
  userData: {},
  accountData: [],
  authentication: {
    showNextStep: JSON.parse(localStorage.getItem("step")) || 0,
    signupData: {},
    tradingPlatforms: [],
    tradingDemoPlatforms: [],
  },
  suitable: {},
  demoBackendAccounts: [],
  liveBackendAccounts: [],
  systemCurrencies: [],
  paymentHistory: [],
  transactionHistory: [],
  uploadPresets: [],
  uploadedDocuments: [],
  depositMethods: [],
  paymentsGateway: [],
  bankAccountForms: {},
  bankAccounts: [],
  withdrawalMethods: [],
  availableCards: [],
  cardRequests: [],
  countries: [],
  userCountry: {},
  ibSummary: {},
  trackingLinks: {},
  trackingLinksWhitelabels: [],
  clientList: [],
  subIbClientList: [],
  subIbList: [],
  ibUploadDocuments: [],
  ibProfile: {},
  ibPaymentHistory: [],
  paymentsInfo: {},
  ibWithdrawalMethods: [],
  withdrawRequests: [],
  leadForms: [],
  liveAccounts: [],
  lang: localStorage.getItem("lang") || "",
  en: {},
  showSidebar: false,
  showAddNewBankAccount: false,
  showAlertNav: false,
  alertNavMessage: "",
  selectedAccountId: "",
  annualCheck: false,
  gccShopPopupAfterDemo: false,
  mobileLoginLink: "",
  ssoToken: "",
  icmAcademyModal: false,
  showIcmAcademyModal: true,
  showICMPopup: false,
  showICMProofModal: "",
  icmCapitalSuitableModal: false,
  widgetToken: "",
  zendeskRegular: "",
  limitedStateUpgradeModal: false,
  limitedUserMessage: false,
  proofOfIdModal: false,
  statusChangeMessageModal: false,
  dailyDepositTotal: null, // BR#151 4/2/2026 daly deposit toal limit - crypto - icmtrader 
  //taxLockout: true, // BR#98 Mbeng 9/06/2025 For ICMMU Tax details
  taxLockout: false, 
  countryRiskMap: {}, //BR#181 Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
};

export default {
  ...INITIAL_STATE,
  loading: false, // sep_5_spinner
  loadingMessage: "", // sep_5_spinner
};
